// --------------------------------------------------
//   Imports
// --------------------------------------------------

// React
import { useState, useEffect, useRef } from 'react';

// Material UI
import {
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";
import CheckIcon from '@mui/icons-material/Check';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

// Custom Components
import RenderIf from '../utils/RenderIf';



// --------------------------------------------------
//   Component
// --------------------------------------------------

export default function DeviceList({
  devices,
  onSelect,
  selected   = null,
  showIDs    = false,
  listStyles = null,
  textStyles = null,
  border     = "",
  icon       = null,
}) {

  // const [selected, setSelected] = useState(null);

  // Fallback device list
  devices = devices || [];

  // Fallback icon
  icon = icon ?? (<CheckIcon />);

  return (
    <List sx={{border, ...listStyles}}>
      {(devices).map((device, idx) => (

        <ListItem key={idx}
          sx={{
            borderBottom: idx === devices.length - 1 ? null : border,
          }}
          disableGutters disablePadding
        >
          <ListItemButton onClick={() => onSelect(device.deviceId)}>

            <ListItemAvatar>
              <RenderIf condition={device.deviceId === selected}>
                <Avatar sx={{ bgcolor: "#4447ad", fontSize: "18px", height: "36px", width: "36px" }}>{ icon }</Avatar>
              </RenderIf>
            </ListItemAvatar>

            <ListItemText
              primary={device.label}
              primaryTypographyProps={textStyles}
              secondary={showIDs ? device.deviceId : null}
              secondaryTypographyProps={{
                variant: "caption",
                sx: { "overflow-wrap": "anywhere", ...textStyles },
              }}
              sx={{ paddingY: "4px" }}
            />

          </ListItemButton>
        </ListItem>

      ))}
    </List>
  )
}
